import { render, staticRenderFns } from "./UserProcessWrapper.vue?vue&type=template&id=a97c5f14&scoped=true&"
import script from "./UserProcessWrapper.vue?vue&type=script&lang=js&"
export * from "./UserProcessWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UserProcessWrapper.vue?vue&type=style&index=0&id=a97c5f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c5f14",
  null
  
)

export default component.exports